import {
  RESET_GOALS,
  RESET_GOAL,
  RESET_ERROR,
  GET_GOALS,
  SET_GOALS,
  API_ERROR,
  GET_GOAL,
  SET_GOAL,
  CREATE_GOAL,
  CREATE_GOAL_SUCCESS,
  EDIT_GOAL,
  EDIT_GOAL_SUCCESS,
  DELETE_GOAL,
  DELETE_GOAL_SUCCESS,
} from "./actionTypes";

export const resetGoals = () => {
  return {
    type: RESET_GOALS,
    payload: {},
  };
};

export const resetGoal = () => {
  return {
    type: RESET_GOAL,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getGoals = (page, qnt, name) => {
  return {
    type: GET_GOALS,
    payload: { page, qnt, name },
  };
};

export const setGoals = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_GOALS,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createGoal = (newGoalValues) => {
  return {
    type: CREATE_GOAL,
    payload: { newGoalValues },
  };
};
export const createGoalSuccess = (message) => {
  return {
    type: CREATE_GOAL_SUCCESS,
    payload: { message },
  };
};

export const getGoal = (idGoal, isForm) => {
  return {
    type: GET_GOAL,
    payload: { idGoal, isForm },
  };
};
export const setGoal = (data) => {
  return {
    type: SET_GOAL,
    payload: { data },
  };
};

export const editGoal = (idGoal, newGoalValues) => {
  return {
    type: EDIT_GOAL,
    payload: { idGoal, newGoalValues },
  };
};
export const editGoalSuccess = (message) => {
  return {
    type: EDIT_GOAL_SUCCESS,
    payload: { message },
  };
};

export const deleteGoal = (idGoal) => {
  return {
    type: DELETE_GOAL,
    payload: { idGoal },
  };
};
export const deleteGoalSuccess = (message) => {
  return {
    type: DELETE_GOAL_SUCCESS,
    payload: { message },
  };
};
